import React, { memo, useContext } from "react";
import { makeStyles } from "@mui/styles";
import {
  Box,
  // Checkbox,
  // FormControlLabel,
  IconButton,
  TableCell,
  TableRow,
  TextField,
  MenuItem,
  InputAdornment,
} from "@mui/material";

import { Cancel, Check } from "@mui/icons-material";

import { useState } from "react";

import AuthContext from "../../../../Context/Auth/AuthContext";
import { replaceCaracteres, trimPropsItem } from "../../../../config/const";
const useRowStyles = makeStyles((theme) => ({
  root: {
    "& > *": {
      borderBottom: ".5px solid #ccc",
    },
  },
  margin: {
    margin: "0px",
    padding: "2px",
  },
  active: {
    borderBottom: "5px solid #ccc",
    backgroundColor: "#354046",
  },
  color: {
    color: "white",
    margin: "0px",
    padding: "2px",
  },
}));

const RowAgregar = (props) => {
  const { setagregar, socket } = props;
  const [item, setitem] = useState({
    //   planId: 1,
    planEstado: "NUEVO", //,
    planTipo: "Home",
    planNombre: "",
    planValor: "",
    planEmpresa: "",
    planMegas: "0",
    planObservacion: "",
    planUser: "",
    planFecReg: "",
    Todos: "",
  });

  const classes = useRowStyles();
  //gql eliminar user

  const { usuario } = useContext(AuthContext);
  const handleAgregar = async () => {
    try {
      console.log(
        trimPropsItem({
          ...item,
          tabla: "plan",
          rucempresa: usuario.rucempresa,
          rol: usuario.rol,
          planUser: usuario.usuario,
          planEmpresa: usuario.rucempresa,
        })
      );
      socket.current.emit(
        "client:guardarData",
        trimPropsItem({
          ...item,
          tabla: "plan",
          rucempresa: usuario.rucempresa,
          rol: usuario.rol,
          planUser: usuario.usuario,
          planEmpresa: usuario.rucempresa,
        })
      );
    } catch (error) {}
  };
  const botonDisabled = () => {
    if (
      item.planTipo.trim() === "" ||
      item.planNombre.trim() === "" ||
      item.planValor.trim() === ""
    ) {
      return true;
    } else {
      return false;
    }
  };
  return (
    <React.Fragment>
      <TableRow className={classes.root}>
        <TableCell></TableCell> {/* boton */}
        <TableCell>
          <Box
            display="flex"
            justifyContent="space-between"
            width="100%"
            alignItems="center"
          >
            <IconButton
              className={classes.margin}
              onClick={() => {
                setagregar(false);
                setitem({
                  //   planId: 1,
                  planTipo: "Home",
                  planNombre: "",
                  planValor: "",
                  planEmpresa: "",
                  planMegas: "0",
                  planObservacion: "",
                  planUser: "",
                  planFecReg: "",
                  Todos: "",
                });
              }}
            >
              <Cancel fontSize="small" color="secondary" />
            </IconButton>
            <IconButton
              color={
                botonDisabled
                  ? botonDisabled()
                    ? "inherit"
                    : "secondary"
                  : "secondary"
              }
              disabled={botonDisabled()}
              className={classes.margin}
              onClick={() => {
                handleAgregar();

                setagregar(false);
                setitem({
                  //   planId: 1,
                  planTipo: "Home",
                  planNombre: "",
                  planValor: "",
                  planEmpresa: "",
                  planMegas: "0",
                  planObservacion: "",
                  planUser: "",
                  planFecReg: "",
                  Todos: "",
                });
              }}
            >
              <Check fontSize="small" />
            </IconButton>{" "}
            {/* <FormControlLabel
              className={classes.margin}
              onChange={(e) => {
                setitem({
                  ...item,
                  secuEstado: e.target.checked ? "ACTIVA" : "INACTIVA",
                });
              }}
              control={
                <Checkbox
                  value="ACTIVO"
                  className={classes.margin}
                  checked={
                    item["secuEstado"] === "ACTIVA" ||
                    item["secuEstado"] === "ACTIVO"
                      ? true
                      : false
                  }
                  color="secondary"
                />
              }
            /> */}
          </Box>
        </TableCell>
        {/* las demas columnas */}
        <TableCell fontSize="small" padding="none">
          <TextField
            value={item.planTipo}
            inputProps={{ style: { textAlign: "center" } }}
            onChange={(e) => {
              const res = replaceCaracteres(e.target.value);
              setitem({
                ...item,
                planTipo: res,
              });
            }}
            helperText="Agregando"
            size="small"
            fullWidth
            select
            SelectProps={{
              displayEmpty: true,
            }}
            InputLabelProps={{ shrink: true }}
          >
            <MenuItem value="">Seleccione </MenuItem>;
            {["Home", "Empresarial", "Coorporativo"].map((item) => {
              return <MenuItem value={item}>{item}</MenuItem>;
            })}
          </TextField>
        </TableCell>
        <TableCell fontSize="small" padding="none">
          <TextField
            value={item.planNombre}
            inputProps={{ style: { textAlign: "center" } }}
            onChange={(e) => {
              const res = replaceCaracteres(e.target.value);
              setitem({
                ...item,
                planNombre: res,
              });
            }}
            helperText="Agregando"
            size="small"
            fullWidth
          />
        </TableCell>
        <TableCell fontSize="small" padding="none">
          <TextField
            value={item.planEstado}
            name="planEstado"
            onChange={(e) => {
              const res = replaceCaracteres(e.target.value);
              setitem({
                ...item,
                planEstado: res,
              });
            }}
            helperText="Agregando"
            size="small"
            fullWidth
            select
            InputLabelProps={{ shrink: true }}
            SelectProps={{ displayEmpty: true }}
          >
            <MenuItem value="">Seleccione.</MenuItem>
            {["ANTIGUO", "ACTUAL", "ANULADO"].map((item) => {
              return (
                <MenuItem
                  key={item}
                  value={item}
                  sx={{
                    color:
                      item === "ANULADO"
                        ? "red"
                        : item === "ANTIGUO"
                        ? "blue"
                        : item === "ACTUAL"
                        ? "green"
                        : "",
                  }}
                >
                  {item}
                </MenuItem>
              );
            })}
          </TextField>
        </TableCell>
        <TableCell fontSize="small" padding="none">
          <TextField
            type="number"
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">$</InputAdornment>
              ),
            }}
            value={item.planValor}
            inputProps={{ style: { textAlign: "center" } }}
            onChange={(e) => {
              const res = replaceCaracteres(e.target.value);
              setitem({
                ...item,
                planValor: res,
              });
            }}
            helperText="Agregando"
            size="small"
            fullWidth
          />
        </TableCell>
        <TableCell fontSize="small" padding="none">
          <TextField
            type="number"
            InputProps={{
              endAdornment: (
                <InputAdornment position="start">MB</InputAdornment>
              ),
            }}
            value={item.planMegas}
            inputProps={{ style: { textAlign: "center" } }}
            onChange={(e) => {
              const res = replaceCaracteres(e.target.value);
              setitem({
                ...item,
                planMegas: res,
              });
            }}
            helperText="Agregando"
            size="small"
            fullWidth
          />
        </TableCell>
        <TableCell fontSize="small" padding="none">
          <TextField
            multiline
            rows={1}
            value={item.planObservacion}
            inputProps={{ style: { textAlign: "center" } }}
            onChange={(e) => {
              const res = replaceCaracteres(e.target.value);
              setitem({
                ...item,
                planObservacion: res,
              });
            }}
            helperText="Agregando"
            size="small"
            fullWidth
          />
        </TableCell>
        <TableCell fontSize="small" padding="none">
          <TextField
            disabled
            value={item.planUser}
            inputProps={{ style: { textAlign: "center" } }}
            onChange={(e) => {
              const res = replaceCaracteres(e.target.value);
              setitem({
                ...item,
                planUser: res,
              });
            }}
            helperText="Agregando"
            size="small"
            fullWidth
          />
        </TableCell>
        <TableCell fontSize="small" padding="none">
          <TextField
            disabled
            value={item.planFecReg}
            inputProps={{ style: { textAlign: "center" } }}
            onChange={(e) => {
              const res = replaceCaracteres(e.target.value);
              setitem({
                ...item,
                planFecReg: res,
              });
            }}
            helperText="Agregando"
            size="small"
            fullWidth
          />
        </TableCell>
      </TableRow>
    </React.Fragment>
  );
};

export default memo(RowAgregar);
